import {
  call,
  cancel,
  cancelled,
  delay,
  fork,
  put,
  select,
  take,
} from 'redux-saga/effects'

import { getBalance, setBalance } from '../../features/balance/balanceSlice'
import { RequestBalance } from '../requests/requestBalance'

export function* balanceAPI() {
  const data = yield select()
  const user = data.user.userAccount.accountName
  console.log(user)
  return new Promise(async (resolve, reject) => {
    try {
      const balance = await RequestBalance(user)
      console.log(user)
      console.log(balance)
      resolve(balance)
    } catch (error) {
      reject(error)
    }
  })
}

export function* resolveBalance() {
  try {
    const balanceData = yield call(balanceAPI)
    const { rows } = yield balanceData
    const data = rows[0].balance.split(' ')
    const dataValue = +data[0]
    const dataName = data[1]
    const obj = {}
    obj[dataName] = dataValue
    yield put(
      setBalance({
        type: 'FETCHING_SUCCESS',
        Balance: obj,
      }),
    )
  } catch (error) {
    const errorMsg = error.toString()
    yield put(setBalance({ type: 'FETCHING_ERROR', error: errorMsg }))
  } finally {
    if (yield cancelled()) {
      yield put(setBalance({ type: 'FETCHING_CANCELLED' }))
    }
  }
}

export function* balanceFlow() {
  while (true) {
    yield put(setBalance({ type: 'GET_BALANCE' }))
    const task = yield fork(resolveBalance)
    const action = yield take(['FETCHING_ERROR'])
    if (action.type === 'STOP_FETCHING') {
      yield cancel(task)
    }
  }
}
